import { useMatches } from "@remix-run/react";
import type { PartnerProfile } from "~/types/partner-profile";

/** Branding comes from a matched server loader, including verified payment previews. */
export function useJourneyPartner(): PartnerProfile | null {
  const matches = useMatches();
  for (const match of [...matches].reverse()) {
    const data = match.data as { partnerData?: PartnerProfile | null } | undefined;
    if (data && "partnerData" in data) return data.partnerData ?? null;
  }
  return null;
}
